import { useEffect, useState } from "react";
import { RootState } from "../../app/store";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setLocation } from "../../features/utils/utilsSlice";

interface Props {
  className?: any;
}

function Banner(props: Props) {
  const [timeLeft, setTimeLeft] = useState("");
  const [promoMessage, setPromoMessage] = useState("");
  const dispatch = useAppDispatch();
  const place = useAppSelector((state: RootState) => state.utils.location);

  // Location is initialized globally at startup; this component just consumes it from the store

  // Mise à jour du compte à rebours + message dynamique
  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const target = new Date();

      let message = "";

      if (now.getHours() < 12) {
        target.setHours(12, 0, 0, 0); // midi
        message =
          "⏳ Dernières heures pour profiter de nos offres spéciales ! 🚨 Livraison gratuite pour toute commande effectuée avant 12 heures ⏳";
      } else {
        target.setHours(24, 0, 0, 0); // minuit
        message =
          "🎁 Remises exceptionnelles jusqu’à ce soir seulement ! 🌟 Livraison gratuite pour toute commande effectuée avant minuit (00 h 00) ⏳";
      }

      const diff = target.getTime() - now.getTime();
      const hours = String(Math.floor(diff / 1000 / 60 / 60)).padStart(2, "0");
      const minutes = String(Math.floor((diff / 1000 / 60) % 60)).padStart(
        2,
        "0"
      );
      const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");

      setTimeLeft(`${hours}:${minutes}:${seconds}`);
      setPromoMessage(message);
    };

    updateCountdown(); // première exécution
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={
        `flex justify-between items-center pr-2 left-0 w-full bg-red-600 text-white py-1 z-50 font-bold` +
        props.className
      }
    >
      <div className="overflow-hidden whitespace-nowrap">
        <div className="animate-marquee inline-block min-w-full text-lg">
          {promoMessage} ⏰ Temps restant : {timeLeft} ⏰
        </div>
      </div>
    </div>
  );
}

export default Banner;
